const translations = {
    en: {
        label_main: "Home",
        label_destinations: "Destinations",
        label_way_to_explore: "Ways to Explore",
        label_not_found: "Page not found...",
        label_back_home: "Back to home page",
        label_faq: "FAQ",
        label_about: "About",

        label_details: "Details",
        label_coming_soon: "Soon...",
        label_upcoming_group_tours: 'UPCOMING ADVENTURES',
        label_experience_title: "Your journey with us",
        label_about_us: "About us",
        label_customer_feedback: "VOYAGER REVIEWS",
        label_adv_cost: "Adventure Cost:",
        label_experience_end_title: "This experience has ended",

        label_trip: 'Trip',
        label_program: 'Itinerary',
        label_hotel: 'Accommodation',
        label_price: 'Adventure Cost',
        label_essential: 'Essentials',
        label_contact_us: 'Get in touch',
        label_name: 'Your Name',
        label_email: 'Your Email Address',
        label_text: 'Let’s plan your adventure',
        label_adventure_text: 'Our adventure plans may be subject to slight adjustments depending on the weather conditions.',
        label_hotel_title: 'Your Comfort Is Our Priority',
        label_travel_essentials: 'Travel Essentials:',

        label_price_include: '✔ Included:',
        label_price_extras: '✘ Extras',
        label_price_activities: 'All activities that are not included in the price must be booked in advance. Please let us know what you\'d like to include in your trip.',

        label_contact_us_title: 'Get in Touch with Us!',
        label_contact_us_subtitle: 'Leave your contact details, and we’ll get back to you soon.',


        button_details: 'Details',
        button_send: 'SEND',
        button_leave_request: 'Leave a Request',
        contact_us_successful: 'Thanks for reaching out! We\'ll be in touch soon.',
        button_ready_to_travel: 'READY TO TRAVEL',

        //home page
        home_main_text: "ar.endezvous",
        home_main_subtext: "Every Journey, A Work of Art",

        about_us_title: 'JOIN US FOR YOUR NEXT ADVENTURE',
        about_us_paragraphs: [
            'At ART Rendezvous, we believe that travel is an art form—a way to connect with the world and yourself. Our name speaks to these meaningful encounters, whether it\'s through the beauty of art, the tranquillity of nature, or the shared passion of fellow travellers. Every journey with us is an opportunity to discover something new—not only about the places you visit but also about your own perspective.',
            'We put careful thought into selecting destinations that bring out the true essence of a place, choosing the best hotels and experiences that reflect the heart of each location. All your travel details, from hotel photos to a full itinerary, are provided upfront, so you can relax and enjoy the trip without any surprises. We include all entrance fees, transport, and provide travel insurance for every guest, ensuring you have peace of mind every step of the way. And of course, we’re always happy to help with any questions or requests you may have along the way.',
        ],

        //destination page
        destination_title: 'THE WORLD TO EXPLORE',
        destination_subtitle: '',

        group_tour_title: "THERE ARE JOURNEYS YOU MAKE AND",
        group_tour_subtitle: "THERE ARE JOURNEYS THAT MAKE YOU",

        group_tour_text: "At ART Rendezvous, we specialise in small-group tours that bring together passionate\ntravellers seeking authentic experiences. Our tours go beyond the usual sights, offering\na deeper connection to the local culture, hidden gems, and natural beauty of each\ndestination.",
        group_tour_subtitle_text: "Our tours are carefully planned to reveal the true essence of each destination, ensuring that you experience all that it has to offer. We take care of all the details, including transportation, accommodation, and activities, so you can enjoy a smooth and effortless journey. With local guides who know the area inside and out, you’ll gain a deeper understanding of the places you visit. Small groups allow for a more personalized and flexible experience, giving you the freedom to explore at your own pace. Everything is included, from transport to entry fees and travel insurance, so you can focus on enjoying the trip. You’ll also have the chance to travel with like-minded people, creating lasting memories and friendships along the way. Our group tours offer the ideal balance of adventure, comfort, and meaningful connection, providing a truly memorable travel experience.",

        gallery_title: "TRAVEL THROUGH OUR LENSES",
        gallery_subtitle: "Photos from our travels.",

        day1: "Day 1",
        day2: "Day 2",
        day3: "Day 3",
        day4: "Day 4",
        day5: "Day 5",
        day6: "Day 6",
        day7: "Day 7",

        way_title: 'Coming soon...',
        way_subtitle: '',


        //georgia
        georgia: "Georgia",
        georgia_price: '£850',
        georgia_date: '23-30 March',
        georgia_date_calendar: '2025-03-25',

        georgia_description_title: "Heartbeats of the Caucasus",
        georgia_descriptions: [
            "Discover two magical worlds, full of beauty, warmth, and ancient traditions. In Georgia, wander the charming streets of Tbilisi, take in the breathtaking views of Kazbegi’s majestic mountains, and savour the famous Georgian food and wine—among the oldest in the world.",
            "In Armenia, be mesmerised by the blue waters of Lake Sevan, the timeless beauty of the Garni Temple, and the lively energy of Yerevan—a city where history and modern life come together.",
            "This trip is a perfect blend of nature, culture, and inspiration from two truly unique countries.",
        ],
        georgia_img1: "Lakes",
        georgia_img2: "Old Tbilisi",
        georgia_img3: "Wine tasting",
        georgia_img4: "Traditional Cuisine",
        georgia_img5: "Museums",
        georgia_img6: "Architectural Landmarks",

        georgia_d1: 'Arrival',
        georgia_activity_d1: [
            '• Arrival in Georgia',
            '• Transfer to Hotel (approx 30-minute drive)',
            '• Hotel Check-in',
            '• Relax at the Hotel',
            '• Breakfast at the Hotel',
            '• Free time',
            '• Lunch at Chveni',
            '• Walk Around Old Tbilisi',
            '• Supra Experience',
        ],
        georgia_d2: 'Tour to Kazbegi',
        georgia_activity_d2: [
            '• Jinvali Reservoir',
            '• Ananuri Fortress',
            '• Gudauri Resort & Friendship Arch',
            '• Stepantsminda (Kazbegi) & Gergeti Trinity Church',
        ],
        georgia_d3: 'Tbilisi',
        georgia_activity_d3: [
            '• Explore Sololaki’s streets, photo spots, and architecture.',
            '• Visit Moorish House, Beria’s mansion, and famous homes.',
            '• Walk through Abenotubani, learn Tbilisi’s history.',
            '• See the waterfall in the city centre.',
            '• Visit Gabriadze Puppet Theatre, Bridge of Peace, and Shardeni Street.',
            '• Learn Georgian feasting traditions from the Tamada.',
            '• Taste wines at a 17th-century cellar.',
            '• Visit Narikala Fortress, Mother of Georgia statue.',
            '• Explore the Chronicles of Georgia fresco.',
        ],
        georgia_d4: 'Mtskheta&Transfer to Armenia',
        georgia_activity_d4: [
            '• Visit Jvari Monastery',
            '• Learn about the first cross and legends of Jvari.',
            '• Explore Svetitskhoveli Monastery and the history of Mtskheta.',
            '• Visit Samtavro Monastery',
            '• Transfer to Armenia (Yerevan). - appox 5-7 hours',
            '• Hotel chevk in in Yerevan',
        ],
        georgia_d5: 'Lake Sevan&Yerevan',
        georgia_activity_d5: [
            '• Drive to Armenia (approx. 5 hours).',
            '• Visit Lake Sevan, known for its vivid blue waters.',
            '• Explore the peaceful Ayravank Monastery.',
            '• Arrive in Yerevan, Armenia’s lively capital.',
        ],

        georgia_d6: 'Garni&Symphony of Stones&Yerevan',
        georgia_activity_d6: [
            '• Excursion to the historic Garni Temple.',
            '• Enjoy a relaxed stroll through Yerevan.',
            '• Final evening soaking up the city’s unique charm.',
        ],

        georgia_d7: 'Homeward Bound',
        georgia_activity_d7: [
            '• Transfer to the airport.',
            '• Departure and farewell to beautiful countries.',
        ],

        georgia_program_d1: [
            'Upon arrival in Georgia, we will greet you at the airport and transfer you to your hotel, a short 30-minute drive. After check-in, you can relax and settle in. Enjoy a traditional Georgian breakfast at the hotel, followed by some time to unwind. For lunch, we will take you to Chveni, where you\'ll enjoy a delicious and authentic Georgian meal. Afterward, we\'ll explore the historic streets of Old Tbilisi, taking in the local architecture and charm. The evening will be dedicated to a special supra dinner, hosted by a family of winemakers and chefs. During this traditional feast, we will introduce you to Georgian culinary customs, guide you through the art of toasting, and share the unique drinking traditions of Georgia—all while enjoying incredible food and the warm hospitality of the hosts.'
        ],
        georgia_program_d2: [
            'On day two, we will visit the beautiful Jinvali Reservoir, surrounded by mountains, with an optional boat ride on its turquoise waters. We’ll then explore the Ananuri Fortress, where you can admire the churches and towers offering panoramic views of the reservoir.',
            'Next, we’ll head to the Gudauri resort and the Friendship Arch, providing stunning views of the mountains and valleys. We’ll continue to Stepantsminda (Kazbegi) to visit the Holy Trinity Church in Gergeti, which offers spectacular views of Mount Kazbek.',
            'Finally, we’ll enjoy a scenic horse riding experience through the picturesque Kazbegi region and relax by the Aragvi River, soaking in the natural beauty.',
        ],
        georgia_program_d3: [
            'On day three, we will explore Tbilisi’s historic districts. We’ll wander through the picturesque Sololaki streets, visiting key sites like the Moorish House, Beria’s mansion, and places where Tchaikovsky, Gumilyov, and Lermontov once lived.\n',
            'We’ll head to Abenotubani to learn about Tbilisi’s origins and see the waterfall in the city centre. Then, we’ll visit the Gabriadze Puppet Theatre, the Bridge of Peace, and Shardeni Street.\n',
            'We’ll also hear about Georgian feasting traditions from the Tamada and visit a 17th-century wine cellar for a wine tasting. Finally, we’ll enjoy views from Narikala Fortress, visit the Mother of Georgia statue, and explore the Chronicles of Georgia fresco.\n',
        ],
        georgia_program_d4: [
            'On day four, we will start by visiting Jvari Monastery, where we’ll discuss its history, the first cross erected by Saint Nino and King Mirian, and the stunning view of the confluence of the rivers that inspired Lermontov’s Mtsyri.',
            'Next, we’ll head to Svetitskhoveli Monastery in Mtskheta, learning about its significance, where Christ’s robe and the relics of Saint Andrew are kept.\n',
            'We’ll then visit Samtavro Monastery, with its 4th-century church, the tombs of Georgia’s first Christian king and Queen Nana, and the miraculous blackberry bush where Saint Gabriel Samtavro once preached.\n',
            'After this, we’ll transfer to Armenia (Yerevan).\n',
        ],
        georgia_program_d5: [
            'After breakfast, head towards Armenia. On the way, you’ll visit the picturesque Lake Sevan with its crystal-clear waters and the ancient Hayravank Monastery. By evening, you’ll arrive in Yerevan, a city brimming with charm and character.',
        ],
        georgia_program_d6: [
            'Start the day with a trip to the ancient pagan temple of Garni. The rest of the day is yours to explore Yerevan’s delightful streets, hidden courtyards, and the vibrant spirit of Armenian culture that fills the city.'
        ],
        georgia_program_d7: [
            'With your heart full of warm memories, breathtaking mountain views, and the incredible hospitality of Georgia and Armenia, it’s time to head back home. This journey is sure to leave a lasting impression.'
        ],


        georgia_hotel_title: 'Your Comfort Is Our Priority',
        georgia_hotel_text: [
            'In Georgia and Armenia, we’ll be staying in carefully selected accommodations that offer a comfortable and inviting environment. While the photos on the website might not exactly match the places we’ll be staying, rest assured they will be very similar, if not the same. We take great care in handpicking each location to ensure your stay is as comfortable and enjoyable as possible.',
            'Please also note that rooms will be shared with individuals of the same gender, with a maximum of three people per room, ensuring a pleasant and respectful atmosphere throughout your stay.',
        ],

        georgia_price_included: [
            '• Accommodation: A stay in cosy, carefully selected hotels throughout the trip.',
            '• Breakfasts: Enjoy a delicious breakfast at your hotel every morning.',
            '• Transfers:',
            '• Airport pick-up and drop-off.',
            '• Comfortable transfers between locations.',
            '• Return transfer to the airport.',
            '• A Packed Itinerary of Activities, including:',
            '• Horse riding through stunning landscapes.',
            '• A hands-on masterclass in making traditional khachapuri.'
        ],

        georgia_price_not_included: ['• Meals (unless specifically mentioned in the itinerary).',
            '• Flights to and from the destination.'],

        //lofoten
        lofoten: "Lofoten Islands",
        lofoten_price: '£795',
        lofoten_date: '8-12 September',
        lofoten_date_calendar: '2025-09-08',

        lofoten_description_title: "Nordic Serenity by the Sea",
        lofoten_descriptions:
            [
                "Above the Arctic Circle lies Lofoten, a land of dramatic peaks, clear fjords, and charming fishing villages. From hiking Reinebringen to kayaking calm waters or unwinding in a traditional sauna, Lofoten offers the perfect mix of adventure and tranquillity. Explore Viking history, savour fresh seafood, and experience the breathtaking beauty of this unforgettable destination.",
            ],

        lofoten_img1: "Hiking",
        lofoten_img2: "Norwegian cuisine",
        lofoten_img3: "Kayaking",
        lofoten_img4: "Sauna",
        lofoten_img5: "Fjords",
        lofoten_img6: "Museums",

        lofoten_activity_d1: [
            '• Arrival to Bodø',
            '• Transfer by ferry to Moskenes ',
            '• Accommodation check-in',
        ],

        lofoten_activity_d2: [
            '• Reinebringen hike 1.1 km',
            '• Hamnøy, Glass Vikten AS',
            '• Kvalvik Beach',
            '• Fredvang',
            '• Dinner in Nusfjord Resort',
            '• Back to Accommodation',
        ],
        lofoten_activity_d3: [
            '• Flakstadbruene',
            '• Lofotr Viking Museum (optional)',
            '• Aalan Gard',
            '• Kayaking (optional)',
            '• Dinner',
            '• Back to Accommodation',
        ],
        lofoten_activity_d4: [
            '• Hov Horge – horse riding (optional)',
            '• Børsen Spiseri',
            '• Magic Ice Lofoten (optional)',
            '• Sauna (optional)',
            '• Dinner',
            '• Back to Accommodation',
        ],
        lofoten_activity_d5: [
            '• Final breakfast',
            '• Farewell to Lofoten',
        ],

        lofoten_d1: 'Arrival',
        lofoten_d2: 'Reinebringen, Hamnøy & Coastal Beauty',
        lofoten_d3: 'Viking History & Kayaking at Sunset',
        lofoten_d4: 'Horse Riding & Sauna',
        lofoten_d5: 'Departure',

        lofoten_program_d1: [
            'We’ll land in Bodø and, if time allows, explore a bit before catching the ferry to Moskenes. The ride itself is a highlight, with incredible views of the sea and surrounding mountains. Once we arrive, we’ll settle into our accommodation, have dinner, and relax for the evening.'
        ],
        lofoten_program_d2: [
            'We’ll kick off the day with a hike up Reinebringen (1.1 km) for breathtaking views of the fjords. Afterwards, we’ll visit the picturesque village of Hamnøy, followed by a stop at Glass Vikten AS, where we can watch glassblowers at work and browse their creations. Later, we’ll unwind at the peaceful Kvalvik Beach before heading to Fredvang to see its famous bridges. After dinner, we will return to our accommodation for the night.'
        ],
        lofoten_program_d3: [
            'We’ll start the day by crossing the Flakstadbruene bridges taking in the scenery along the way. Our first stop is the Lofotr Viking Museum, where we’ll step back in time and learn about Viking history. Then, we’ll visit Aalan Gard, a charming goat farm known for its organic cheeses. In the evening, we’ll kayak at sunset, a perfect way to experience Lofoten’s coastline. We’ll wrap up the day with a dinner in one of the local Norwegian restaurants.'
        ],
        lofoten_program_d4: [
            'Our final day begins with a horse ride at Hov Horge, an amazing way to take in the landscape. For lunch, we’ll enjoy traditional Lofoten dishes at Børsen Spiseri. After the ride, we’ll visit Henningsvær Stadium, one of the world’s most scenic football fields, surrounded by dramatic coastal views. For lunch, we’ll enjoy traditional Lofoten dishes at Børsen Spiseri. Afterwards, we’ll visit Magic Ice Lofoten, where we’ll admire ice sculptures and enjoy a drink. Before heading back, we’ll relax in a sauna, have a final dinner, and return to our accommodation for the night, wrapping up an unforgettable trip.'
        ],
        lofoten_program_d5: [
            'After a final breakfast, we’ll check out and head to Moskenes for the ferry back to Bodø. From there, we’ll continue our journey home, taking with us unforgettable memories of Lofoten.'
        ],

        lofoten_hotel_title: 'Apartments',
        lofoten_hotel_text: [
            'In Lofoten, we’ll be staying in carefully selected accommodations that offer a comfortable and inviting environment. While the photos on the website might not exactly match the places we’ll be staying, rest assured they will be very similar, if not the same. We take great care in handpicking each location to ensure your stay is as comfortable and enjoyable as possible.',
            'Please also note that rooms will be shared with individuals of the same gender, with a maximum of three people per room, ensuring a pleasant and respectful atmosphere throughout your stay.',
        ],

        lofoten_price_included: [
            '• Accommodation',
            '• Transfers to and from the airport',
            '• Transfers between locations',
            '• Ferry from Bodø to Lofoten and return',
            '• Guided trips',
            '• Travel insurance (basic fee)'
        ],
        lofoten_price_not_included: [
            '• Flight tickets',
            '• Meals (we’ll carefully handpick affordable restaurants or cafes, and when possible, prepare meals together at our apartments)’',
            '• Viking Museum – £20',
            '• Sunset Kayaking – £100',
            '• Horse Riding – £110',
            '• Magic Ice Lofoten – £25',
            '• Sauna – £50',
        ],

        lofoten_price_final: 'Cost of the Trip to Lofoten, Norway - £795',

        lofoten_essential_title: 'Essential Items for a Summer Adventure in Lofoten',

        //norway
        norway: "Norway",
        norway_price: '£890',
        norway_date: '17-22 June',
        norway_date_calendar: '2025-06-17',

        norway_description_title: "Legends of the Fjords",
        norway_descriptions: [
            "Explore Norway’s dramatic landscapes, from towering cliffs and waterfalls to crystal-clear lakes and ancient glaciers. Hike to stunning viewpoints, visit historic Viking sites, and take in the beauty of Bergen. With options like kayaking and a traditional sauna, every day brings something new and unforgettable.",
        ],

        norway_img1: "Trollutnga",
        norway_img2: "Viking Village",
        norway_img3: "Glaciers",
        norway_img4: "Kayaking",
        norway_img5: "Bergen",
        norway_img6: "Sauna",

        norway_activity_d1: [
            '• Arrival in Norway',
            '• Check-in at our accommodation',
        ],

        norway_activity_d2: [
            '• Hike to Trolltunga (10–12 hours)',
            '• Sauna experience (optional)',
        ],
        norway_activity_d3: [
            '• Hike to Vøringfossen',
            '• Immersive experience at Viking Valley',
            '• Visit to Stegastein (if time allows)',
        ],
        norway_activity_d4: [
            '• Jostedalsbreen Glacier',
            '• Lovatnet Lake',
            '• Kayaking (optional)',
        ],
        norway_activity_d5: [
            '• Return to Bergen (approximately 4-hour drive)',
            '• Explore Bergen',
        ],
        norway_activity_d6: [
            '• Breakfast in Bergen (if time allows)',
            '• Departure',
        ],

        norway_d1: 'Arrival',
        norway_d2: 'Trolltunga Hike & Sauna',
        norway_d3: 'Vøringfossen, Viking Valley & Relocation',
        norway_d4: 'Jostedalsbreen Glacier & Lovatnet Lake',
        norway_d5: 'Return to Bergen & Exploration',
        norway_d6: 'Farewell & Departure',

        norway_program_d1: [
            'Our journey begins with our arrival in Norway. This will be a relaxed day, allowing us to settle in, check into our accommodation, and prepare for the adventures ahead. We’ll take some time to gather supplies, including snacks and food for the following day, ensuring we’re well-prepared for the challenges to come.'
        ],
        norway_program_d2: [
            'We’ll have an early start, as the Trolltunga hike is a demanding yet rewarding experience, taking approximately 10 to 12 hours. After a hearty breakfast at our accommodation, we’ll set off with packed meals prepared the night before. The hike is challenging but promises breathtaking views, making every step worthwhile. After our return, there will be an opportunity to unwind with a sauna experience—completely optional but a perfect way to relax after an intense day.'
        ],
        norway_program_d3: [
            'We begin the day with a hike to Vøringfossen, one of Norway’s most stunning waterfalls. From there, we’ll step back in time with an experience at Viking Valley, where a traditional Viking-style dinner awaits us. If time permits, we’ll also visit the viewpoint at Stegastein before heading to our next accommodation.'
        ],
        norway_program_d4: [
            'Today’s adventure takes us to Jostedalsbreen, Norway’s largest glacier, where we’ll have the chance to witness its awe-inspiring landscapes up close. Following this, we’ll visit the stunning Lovatnet Lake. Here, there will be an option to go kayaking, offering a peaceful yet thrilling way to take in the surrounding beauty.'
        ],
        norway_program_d5: [
            'We’ll make our way back to Bergen, a journey of around four hours, and spend the day exploring this vibrant city. From its charming streets to its rich cultural heritage, Bergen offers a wonderful way to conclude our trip. Tonight, we’ll stay in our final accommodation, soaking in our last evening together before departure the next day.'
        ],
        norway_program_d6: [
            'Our journey comes to an end, and it’s time to say our goodbyes. After an incredible adventure, we’ll part ways, taking with us unforgettable memories of Norway’s landscapes, history, and experiences.'
        ],

        norway_hotel_title: 'Accommodation',
        norway_hotel_text: [
            'In Norway, we’ll be staying in carefully selected accommodations that offer a comfortable and inviting environment. While the photos on the website might not exactly match the places we’ll be staying, rest assured they will be very similar, if not the same. We take great care in handpicking each location to ensure your stay is as comfortable and enjoyable as possible.',
            'Please also note that rooms will be shared with individuals of the same gender, with a maximum of three people per room, ensuring a pleasant and respectful atmosphere throughout your stay.',
        ],

        norway_price_included: [
            '• Accommodation',
            '• Transfers to and from the airport',
            '• Transfers between locations',
            '• Trolltunga coach & Parking fees',
            '• Viking dinner',
            '• Travel insurance (basic fee) )'
        ],

        norway_price_not_included: [
            '• Flight tickets',
            '• Meals (we’ll carefully handpick affordable restaurants or cafes, and when possible, prepare meals together at our apartments)’',
            '• Kayaking - £75',
            '• Sauna - £25',
        ],

        norway_essential_title: 'Essential Items for a Summer Adventure in Lofoten',

        nordic_essential_items: [
            ' • Waterproof jacket and trousers',
            ' •	Warm layers (thermal underwear, jumpers, fleece)',
            ' •	Hat, gloves, and scarf (it can get chilly, even in summer)',
            ' •	Sturdy waterproof boots for walking',
            ' •	Sunscreen ',
            ' •	Lip balm with SPF (the wind can be harsh on your skin)',
            ' •	Swimsuit',
            ' •	Sunglasses',
            ' •	Reusable water bottle',
            ' •	Backpack',
            ' •	Personal prescription medications (painkillers, antihistamines, motion sickness tablets)\n',
            ' •	First aid kit (plasters, antiseptic wipes, etc.)',
            ' •	Any necessary allergy medications ',
        ],

        // italy como
        italy: "Італія Комо",
        italy_como: "Lake Como",
        italy_como_price: '£645',
        italy_como_date: '3-6 July',
        italy_como_date_calendar: '2025-07-03',

        italy_como_description_title: "Beyond the Blue Waters",
        italy_como_descriptions: [
            'Explore the beauty of Northern Italy, from Milan\'s famous landmarks to the picturesque villages of Lake Como. Experience the charm of Bellagio and Varenna, enjoy scenic boat trips, and discover stunning villas, all while enjoying the rich culture and breathtaking views this region has to offer'
        ],


        italy_como_img1: "VILLA BALBIANELLO",
        italy_como_img2: "BOAT TOUR",
        italy_como_img3: "ITALIAN CUISINE ",
        italy_como_img4: "MILAN",
        italy_como_img5: "BELLAGIO",
        italy_como_img6: "VARENNA",

        italy_como_activity_d1: [
            '• Arrive in Milan',
            '• Explore Milan (Duomo, Galleria Vittorio Emanuele II, Brera)',
            '• Check-in at hotel (Como)',
        ],

        italy_como_activity_d2: [
            '• Visit Villa Balbianello',
            '• Explore Tremezzo (Villa Carlotta)',
            '• Bellagio',
        ],
        italy_como_activity_d3: [
            '• Private boat trip',
            '• Photoshoot (optional)',
            '• Visit Villa Monastero',
            '• Explore Varenna',
        ],
        italy_como_activity_d4: [
            '• Final breakfast',
            '• Farewell to Italy',
        ],

        italy_como_d1: 'Arrival & Milan Exploration',
        italy_como_d2: 'Discovering the Gems of Lake Como',
        italy_como_d3: 'Scenic Boat Trip & Cultural Highlights',
        italy_como_d4: 'Farewell & Departure',

        italy_como_program_d1: [
            'We will arrive in Milan, ready to begin our adventure. Our first day will be spent strolling through the city\'s most iconic landmarks, from the breathtaking Duomo to the elegant Galleria Vittorio Emanuele II and the charming streets of Brera. In the evening, we will gather for a delightful group dinner before making our way to our hotel near Lake Como for check-in and a well-earned rest.'
        ],
        italy_como_program_d2: [
            'We will start the day with a visit to Villa Balbianello, a stunning historic estate perched on the lake’s edge. Next, we will explore the scenic town of Tremezzo, home to the enchanting gardens of Villa Carlotta. After soaking up the beauty of the surroundings, we will board a ferry to Bellagio, often called the \'Pearl of Lake Como,\' where we will wander its charming streets and enjoy a meal with breathtaking views of the lake.'
        ],
        italy_como_program_d3: [
            'We will set off on a private boat trip, gliding across the sparkling waters of Lake Como and taking in its majestic scenery. For those who wish, an optional photoshoot will capture the magic of our trip. Later, we will visit Villa Monastero, a lakeside villa with stunning gardens and panoramic views. Our journey continues in the picturesque village of Varenna, where we can relax, explore, and enjoy the laid-back charm of this idyllic spot.'
        ],
        italy_como_program_d4: [
            'On our final morning, we will come together for one last breakfast, reflecting on the unforgettable moments we\'ve shared. With hearts full and cameras packed with memories, we will begin our journey home, carrying with us the beauty and magic of Lake Como.'
        ],

        italy_como_price_final_text: 'хочете повернутися цілим - лишайте чайові',

        italy_como_hotel_title: 'Accommodation',
        italy_como_hotel_text:
            [
                'We will be staying in a carefully selected hotel that provides a welcoming and comfortable environment. While the photos on the website may not be exact representations of our accommodations, they will be very similar, if not identical. We take great care in choosing a hotel that offers both quality and charm, ensuring a pleasant stay for everyone in the group.',
                'Rooms will be shared with individuals of the same gender, with a maximum of three people per room. This arrangement ensures a comfortable and respectful atmosphere, allowing everyone to relax and enjoy their time in the stunning surroundings of Lake Como.',
            ],

        italy_como_price_included: [
            '• Hotel',
            '• Transfers to and from the airport',
            '• Transfers between locations',
            '• Villa Balbianello ticket',
            '• Villa Monastero ticket',
            '• Boat tour',
        ],

        italy_como_price_not_included: [
            '• Flight tickets ',
            '• Meals (lunches and dinners)',
            '• Photoshoot - £100. Each participant will have a dedicated 30-minute session as part of the group experience.',
        ],

        italy_como_essential_title: 'Travel Essentials:',
        italy_como_essential_items: [
            '• Comfortable walking shoes',
            '• Light layers and a waterproof jacket for varying weather conditions',
            '• Sunglasses, hat, and sunscreen',
            '• Small backpack or crossbody bag for day trips',
            '• Swimwear',
        ],

        // iceland
        iceland: "Iceland",
        iceland_price: '£1065',
        iceland_date: '2-7 June',
        iceland_date_calendar: '2025-06-02',

        iceland_description_title: "Land of Fire and Ice",
        iceland_descriptions: [
            "Start your journey through Iceland's breathtaking landscapes, from towering waterfalls and vast glaciers to volcanic plains and black sand beaches.",
            "Discover stunning natural wonders, including the iconic Gullfoss and hidden Gljúfrabúi waterfalls, the eerie Sólheimasandur Plane Wreck, and the vibrant geothermal beauty of Landmannalaugar. ",
            "This adventure offers an unforgettable experience of Iceland's wild beauty, ​​where every traveller can uncover a part of themselves. "
        ],

        iceland_img1: "WHALE WATCHING",
        iceland_img2: "BLUE LAGOON ",
        iceland_img3: "ROAD TRIPS",
        iceland_img4: "SÓLHEIMASANDUR PLANE WRECK",
        iceland_img5: "REYKJAVIK",
        iceland_img6: "WILDLIFE",

        iceland_activity_d1: [
            '• Arrival to Iceland',
            '• Check-in at our accommodation',
        ],

        iceland_activity_d2: [
            '• Gullfoss',
            '• Gljúfrabúi waterfall',
            '• Sólheimasandur Plane Wreck',
            '• Reynisfjara Beach (black sands)',
        ],

        iceland_activity_d3: [
            '• Thórsmörk hike (8-10 hours)',
        ],
        iceland_activity_d4: [
            '• Mýrdalsjökull Glacier',
            '• Landmannalaugar hike (30-40 mins)',
            '• Háifoss',
            '• Hvítárvatn',
        ],
        iceland_activity_d5: [
            '• Reykjavik',
            '• Whale watching (optional)',
            '• Blue Lagoon (optional)',
        ],
        iceland_activity_d6: [
            '• Breakfast in Reykjavik (if time allows)',
            '• Farewell to Iceland',
        ],

        iceland_d1: 'Arrival',
        iceland_d2: 'Waterfalls, Black Sands & a Plane Wreck',
        iceland_d3: 'Thórsmörk Hiking Expedition',
        iceland_d4: 'Glaciers, Highlands & Waterfalls',
        iceland_d5: 'Reykjavik & Whale Watching & Blue Lagoon',
        iceland_d6: 'Farewell to Iceland',

        iceland_program_d1: [
            'We arrive in Iceland and check in at our accommodation, getting some rest before our journey through this incredible country begins.'
        ],
        iceland_program_d2: [
            'We kick off our adventure with a visit to the breathtaking Gullfoss, one of Iceland’s most powerful waterfalls. From there, we explore the hidden Gljúfrabúi, a secret waterfall tucked away behind a canyon wall. Next, we take on the hike to the Sólheimasandur Plane Wreck, where the haunting remains of a U.S. Navy aircraft rest against the stark black sands. Our final stop of the day is Reynisfjara Beach, home to the famous basalt columns and roaring Atlantic waves.'
        ],
        iceland_program_d3: [
            'Today, we embark on a full-day hike (8-10 hours) through Thórsmörk, a valley surrounded by glaciers, rivers, and rugged peaks. As we make our way through the dramatic landscapes, we’ll cross rivers, trek through lush green valleys, and take in breathtaking mountain views. This is one of Iceland’s most rewarding hikes, and by the end of the day, we’ll have experienced the country’s raw beauty up close.'
        ],
        iceland_program_d4: [
            'We start the day at Mýrdalsjökull Glacier, one of Iceland’s most stunning ice caps, where we can take in the incredible views of the frozen wilderness. Then, we head to Landmannalaugar, known for its colourful rhyolite mountains, where we take a short 30-40 minutes hike to soak in the otherworldly scenery. Afterwards, we visit Háifoss, one of Iceland’s tallest waterfalls, cascading down from a height of 122 meters. Our final stop is Hvítárvatn, a glacial lake with stunning reflections of the surrounding mountains.'
        ],
        iceland_program_d5: [
            'We spend the day exploring Reykjavik, diving into its culture, architecture, and vibrant atmosphere. There’s also the option to head out for a whale-watching tour, where we may spot minke whales, humpbacks, or even orcas in the wild. Later, for those who want to unwind, we can visit the Blue Lagoon, soaking in its warm, mineral-rich waters surrounded by lava fields.'
        ],
        iceland_program_d6: [
            'We enjoy a final breakfast (if time allows) in Reykjavik, taking in the last moments of our journey before heading to the airport. It’s time to say goodbye to this beautiful country, but the memories will stay with us forever.'
        ],

        iceland_hotel_title: 'Accommodation',
        iceland_hotel_text:
            [
                'In Iceland, we’ll be staying in carefully selected accommodations that offer a comfortable and inviting environment. While the photos on the website might not exactly match the places we’ll be staying, rest assured they will be very similar, if not the same. We take great care in handpicking each location to ensure your stay is as comfortable and enjoyable as possible.',
                'Please also note that rooms will be shared with individuals of the same gender, with a maximum of three people per room, ensuring a pleasant and respectful atmosphere throughout your stay.',
            ],

        iceland_price_included: [
            '• Accommodation',
            '• Transfers to and from the airport',
            '• Transfers between locations',
            '• Tours to locations',
            '• Travel insurance',
        ],

        iceland_price_not_included: [
            '• Flight tickets',
            '• Meals (we’ll carefully handpick affordable restaurants or cafes, and when possible, prepare meals together at our apartments)',
            '• Blue Lagoon - £100',
            '• Whale watching - £85',
        ],

        iceland_price_final: 'Price: £1065',

        iceland_essential_title: 'Travel Essentials for Iceland:',


        // portugal
        portugal: "Portugal",
        portugal_text: 'Waves & Wonders of Portugal',
        portugal_price: '£950',
        portugal_date: '15-20 July',
        portugal_date_calendar: '2025-06-15',

        portugal_description_title: "Waves & Wonders of Portugal",
        portugal_descriptions:
            ["Join us for an unforgettable adventure in Portugal, where you’ll spend six days surfing with experienced instructors, exploring stunning destinations like Lisbon, Porto, and Sintra, and indulging in delicious Portuguese cuisine.",
                "Whether you’re looking to improve your skills or just soak up the vibes, you’ll make new friends, create lasting memories, and have the time of your life. See you on the waves!",
            ],

        portugal_img1: "Visit Porto",
        portugal_img2: "Surfing",
        portugal_img3: "Visit Nazare",
        portugal_img4: "Visit Lisbon",
        portugal_img5: "Visit Sintra",
        portugal_img6: "Yoga",


        portugal_activity_d1: [
            '• Arrival',
            '• Welcome Dinner',
            '• Yoga'
        ],

        portugal_activity_d2: [
            '• Breakfast',
            '• Surf Lesson',
            '• Trip to Nazaré',
            '• Yoga',
        ],
        portugal_activity_d3: [
            '• Breakfast',
            '• Surf Lesson',
            '• Free Time',
            '• Bike Tour',
            '• Group Gathering',
            '• Yoga',
        ],
        portugal_activity_d4: [
            '• Breakfast',
            '• Surf Lesson',
            '• Trip to Lisbon',
            '• Yoga',
        ],

        portugal_activity_d5: [
            '• Breakfast',
            '• Surf Lesson',
            '• Trip to Porto',
            '• Nightlife Exploration',
        ],
        portugal_activity_d6: [
            '• Breakfast',
            '• Surf Lesson',
            '• Farewell',
        ],

        portugal_activity_additional_info: "Surf lessons and yoga sessions are optional—you decide how to shape your experience!",

        portugal_d1: 'Welcome to Portugal!',
        portugal_d2: 'First Waves & Exploring Nazaré',
        portugal_d3: 'Surf, Explore & Connect',
        portugal_d4: 'Surf & Discover Lisbon',
        portugal_d5: 'Surf & Porto’s Magic',
        portugal_d6: 'One Last Ride & Goodbyes',

        portugal_program_d1: [
            'Arrive and settle into your new home for the next six days. In the evening, we’ll treat you to a delicious welcome dinner where you’ll meet your fellow travelers. Afterward, unwind with an optional sunset yoga session to stretch out from your journey and get into the flow of the week ahead.'
        ],
        portugal_program_d2: [
            'Start the day with a nourishing breakfast before heading to the beach for your first surf lesson. Whether you’re a beginner or have experience, our skilled instructors will guide you. After some time in the water, we’ll take a trip to Nazaré, famous for its record-breaking waves and stunning coastal views. Then, we’ll head to Sintra, a magical town known for its fairy-tale palaces, lush forests, and breathtaking scenery. Wander through its charming streets, explore iconic landmarks like Pena Palace, and soak in the mystical atmosphere before returning for a well-earned.'
        ],
        portugal_program_d3: [
            'Another energizing morning begins with breakfast and an optional surf session. The afternoon is yours to enjoy—relax by the ocean, explore the local area, or simply recharge. Later, we’ll go on a scenic bike tour to discover hidden gems. End the day with an optional yoga session to wind down.'
        ],
        portugal_program_d4: [
            'Fuel up with breakfast before another fun surf session. Then, we’ll head to Lisbon, Portugal’s vibrant capital, where old-world charm meets modern energy. Wander through historic streets, visit famous landmarks, and immerse yourself in the city’s unique atmosphere. As the evening sets in, you’ll have the option to unwind with yoga or dive into the city’s buzzing nightlife.'
        ],
        portugal_program_d5: [
            'After breakfast and another surf session, we’ll make our way to Porto, a city known for its stunning riverfront, charming old town, and famous port wine. Explore the lively streets, take in the breathtaking views, and experience the city’s dynamic energy. Depending on the vibe, we may spend the night discovering Porto’s nightlife—or perhaps it’ll be Lisbon’s that we explored the night before. Either way, get ready for an unforgettable evening!'
        ],
        portugal_program_d6: [
            'Enjoy your final breakfast with the group before catching a last surf session (if you choose).  Whether it’s the waves, the friendships, or the experiences, you’ll leave with memories that will last a lifetime.'
        ],


        portugal_hotel_title: 'Your Comfort Is Our Priority',
        portugal_hotel_text: [
            'On this tour, we’ve selected only the finest and most reliable hotels to ensure your stay is as relaxing and comfortable as possible. Each apartment has been carefully chosen to provide a perfect retreat after days filled with adventure and exploration.',
            'Below, you’ll find photos of the beautiful accommodations where you’ll be staying—or similar high-quality options carefully selected for your comfort.',
            'Travel with us – we’ve taken care of every detail for your perfect getaway!',
        ],

        portugal_price_included: [
            '• Transfers to and from the airport',
            '• All transfers between locations',
            '• Comfortable accommodation',
            '• Surf sessions',
            '• Yoga lessons',
            '• Daily breakfasts',
            '• A special welcome dinner',
            '• Travel insurance',
            '• All tours, including transfers to Lisbon and Porto',
            '• Tickets for two selected activities'
        ],

        portugal_price_not_included: [
            '• Flight tickets',
            '• Extra surf sessions',
            '• Lunches and dinners (except the welcome dinner)'
        ],

        portugal_price_final: 'Price - £950',

        portugal_essential_title: 'Travel Essentials ',
        portugal_essential_items: [
            '• Swimsuits',
            '• Reef-safe sunscreen (high SPF – the sun can be strong!)\n',
            '• Sunglasses with UV protection\n',
            '• Flip-flops or waterproof sandals',
            '• Lightweight, breathable clothes for warm days',
            '• Sweatshirt or light jacket for cooler evenings',
            '• Casual outfits for exploring nearby towns',
            '• Activewear for warm-ups or yoga sessions',
            '• Hat or cap for sun protection',
            '• Personal Medicines',
        ],

        // faroe island
        faroe: "Faroe Islands",
        faroe_price: '£890',
        faroe_date: '17-21 September',
        faroe_date_calendar: '2025-09-17',

        faroe_upcoming: "Whispers of the North",
        faroe_description_title: "WHISPERS OF THE NORTH",
        faroe_descriptions:
            [
                "Discover the stunning landscapes and unique culture of the Faroe Islands. From dramatic waterfalls and tranquil lakes to charming villages and local experiences, this itinerary offers an unforgettable adventure. Explore the islands' natural beauty, enjoy outdoor activities, and experience Faroese traditions.\n",
            ],

        faroe_img1: "WATERFALLS",
        faroe_img2: "KALLUR LIGHTHOUSE",
        faroe_img3: "TRADITIONS",
        faroe_img4: "SKARDSAFOSSUR",
        faroe_img5: "SØRVÁGSVATN",
        faroe_img6: "PUFFINS",


        faroe_activity_d1: [
            '• Arrival at the Faroe Islands',
            '• Check-in at our accommodation',
            '• Explore surroundings'
        ],

        faroe_activity_d2: [
            '• Skardsafossur',
            '• Mykines',
        ],
        faroe_activity_d3: [
            '• Sørvágsvatn',
            '• Kayaking (optional)',
            '• Witches Finger Trail',
            '• Dinner with a Faroese family at a Faroese farm',
        ],
        faroe_activity_d4: [
            '• Kallur Lighthouse',
            '• Whiskey and Gin Distillery Tour',
        ],

        faroe_activity_d5: [
            '• Final breakfast',
            '• Goodbye to the Faroes',
        ],

        faroe_d1: 'Arrival & Settling In',
        faroe_d2: 'Waterfalls & Mykines Island',
        faroe_d3: 'Sørvágsvatn, Hiking & Local Dinner',
        faroe_d4: 'Lighthouses & Distillery Tour',
        faroe_d5: 'Breakfast & Departure',

        faroe_program_d1: [
            'Our adventure begins as we touch down in the Faroe Islands. After making our way to the accommodation and checking in, we’ll have time to explore the surroundings, get familiar with the area, and ease into the trip. No big plans for today—just a chance to relax, grab a bite to eat, and get ready for the days ahead.'
        ],
        faroe_program_d2: [
            'The day kicks off with a visit to Skardsafossur, a hidden gem that’s off the main tourist path but well worth the stop. From there, we hop on a ferry to Mykines, a rugged island famous for its dramatic cliffs and thriving puffin colonies. We’ll spend the day hiking the trails, soaking in the wild coastal views, and getting up close with the puffins. Expect fresh sea air, sweeping landscapes, and the raw beauty of the Faroes.'
        ],
        faroe_program_d3: [
            'First up is Sørvágsvatn, the legendary lake that appears to hover above the ocean. We’ll walk along the cliffs, take in the illusion from the best vantage points, and for those feeling adventurous, there’s an option to kayak. Next, we tackle the Witches Finger Trail, a scenic hike leading to a striking rock formation with an incredible panoramic view at the top. We end the day with dinner at a traditional Faroese farm, tasting local dishes and getting a glimpse into daily life on the islands.\n'
        ],
        faroe_program_d4: [
            'The morning takes us to Kallur Lighthouse, perched on cliffs with sweeping views in every direction. The hike up is relatively easy, but the scenery makes it unforgettable. In the afternoon, we switch gears with a Whiskey and Gin Distillery Tour, where we’ll learn how Faroese ingredients are used in crafting unique spirits—complete with a tasting to wrap up the experience.'
        ],
        faroe_program_d5: [
            'The final morning is all about taking it slow—one last breakfast, packing up, and saying farewell to the Faroe Islands. For those with extra time before the flight, there’s a chance to take a final stroll and soak in the last moments of this incredible place.'
        ],


        faroe_hotel_title: 'Your Comfort Is Our Priority',
        faroe_hotel_text: [
            'In the Faroe Islands, we’ll be staying in carefully selected accommodations that offer a comfortable and inviting environment. While the photos on the website might not exactly match the places we’ll be staying, rest assured they will be very similar, if not the same. We take great care in handpicking each location to ensure your stay is as comfortable and enjoyable as possible.',
            'Please also note that rooms will be shared with individuals of the same gender, with a maximum of three people per room, ensuring a pleasant and respectful atmosphere throughout your stay.',
        ],

        faroe_price_included: [
            '• Accommodation',
            '• Transfers to and from the airport',
            '• Transfers between locations',
            '• Tours to locations',
            '• Travel insurance',
            '• Dinner with a Faroese family at a Faroese farm',
            '• Whiskey and Gin Distillery Tour',
        ],

        faroe_price_not_included: [
            '• Flight tickets',
            '• Meals (we’ll carefully handpick affordable restaurants or cafes, and when possible, prepare meals together at our apartments)',
            '• Kayaking - £55'
        ],

        faroe_essential_title: 'Travel Essentials for the Faroe Islands:',

        // vietnam
        vietnam: "Vietnam",
        vietnam_date: '15-20 Липня',
        vietnam_date_calendar: '2022-07-15',
    },

    uk: {
        label_main: "Головна",
        label_destinations: "Мандрівки",
        label_way_to_explore: "Відкривай нове",
        label_not_found: "Сторінку не знайдено...",
        label_back_home: "Повернутися на головну сторінку",
        label_about: "Про нас",


        label_details: "Деталі",
        label_coming_soon: "Незабаром...",
        label_upcoming_group_tours: "МАЙБУТНІ ПРИГОДИ",
        label_experience_title: "Твоя подорож з нами",
        label_about_us: "Про нас",
        label_customer_feedback: "ВІДГУКИ МАНДРІВНИКІВ",
        label_adv_cost: "Вартість мандрівки:",
        label_experience_end_title: "Шо було те було",

        label_trip: "Подорож",
        label_program: "Маршрут",
        label_hotel: "Проживання",
        label_price: "Вартість мандрівки",
        label_essential: "Необхідне",
        label_contact_us: "Залиште своє повідомлення",
        label_name: "Ім’я",
        label_email: "Електронна адреса",
        label_text: "Сплануймо нашу пригоду",
        label_adventure_text: "Наші плани пригод можуть зазнавати незначних змін залежно від погодних умов.",
        label_hotel_title: 'Твій комфорт – наш пріоритет',
        label_travel_essentials: 'Необхідні речі для подорожі:',

        label_price_include: "✔ Що включено:",
        label_price_extras: "✘ Не включено",
        label_price_activities: "Усі активності, які не включені у вартість, потрібно бронювати заздалегідь. Будь ласка, повідом нам, що ти хочеш додати до своєї подорожі.",

        label_contact_us_subtitle: "Залиш свої дані, і ми незабаром зв’яжемося з тобою.",

        button_send: 'НАДІСЛАТИ',
        contact_us_successful: 'Дякуємо за звернення! Ми скоро з тобою зв’яжемося.',
        button_ready_to_travel: 'час вирушати',

        //home page
        home_main_subtext: "Кожна подорож – справжнє мистецтво",

        experiences_1_title: 'Групові тури',
        experiences_1_text: [
            'У ART Rendezvous ми спеціалізуємося на турах для невеликих груп, об’єднуючи мандрівників, які прагнуть справжніх вражень. Наші подорожі виходять за межі стандартних маршрутів, відкриваючи глибший зв’язок із місцевою культурою, прихованими перлинами та природною красою кожного місця.',
        ],

        experiences_1_subtitle: 'What we offer:',
        experiences_1_subtext: [
            'Curated Itineraries: Thoughtfully planned to showcase the true essence of each place. Comfort and Convenience: All details, from transport to accommodation, are handled for a smooth journey. Expert Guides: Local guides who bring each destination to life with insider knowledge. Small Groups: More personal, flexible experiences with plenty of space to explore at your own pace. All-Inclusive: Transport, entry fees, and travel insurance are included, so you can relax and enjoy. Shared Experience: Travel with like-minded individuals, making memories and friendships along the way. If you’re looking for a travel experience that’s more than just sightseeing, our group tours offer the perfect blend of adventure, comfort, and connection.',
        ],

        experiences_2_title: 'Private tours',
        experiences_2_text: [
            'For a truly personalised experience, our private tours are the perfect choice. Whether you’re travelling with friends, celebrating a special occasion like a birthday, hen or stag party, enjoying a family getaway, or planning any kind of unique adventure, we’ll create the ideal trip for you.',
            'Simply tell us what you’re looking for, and we’ll handle the rest. From choosing the perfect destination to planning every detail, your private tour is designed around your needs and desires. With complete flexibility, privacy, and an itinerary that suits you, your next adventure is only a flight away.'
        ],

        about_us_title: 'ПРИЄДНУЙСЯ ДО НАШОЇ НАСТУПНОЇ ПРИГОДИ',
        about_us_paragraphs: [
            'У ART Rendezvous ми віримо, що подорожі — це справжнє мистецтво, спосіб відкрити світ і себе в ньому. Наша назва символізує особливі зустрічі: з красою мистецтва, гармонією природи чи натхненням, яке дарують однодумці. Кожна поїздка з нами — це шанс відкрити щось нове не лише про місця, які ви відвідуєте, а й про власний погляд на світ.',
            'Ми ретельно добираємо напрямки, щоб передати справжню атмосферу кожного куточка, обираємо найкращі готелі та унікальні враження, що відображають душу місця. Усі деталі вашої подорожі — від фотографій готелів до детального маршруту — ви отримаєте заздалегідь, тож зможете насолоджуватися мандрівкою без зайвих клопотів. У вартість входять усі вхідні квитки, трансфери, а також страхування, щоб ви почувалися впевнено на кожному етапі подорожі. І, звісно, ми завжди поруч, готові відповісти на будь-які запитання та допомогти з будь-якими побажаннями.',
        ],

        //destination page
        destination_title: 'СВІТ БЕЗ МЕЖ',

        group_tour_title: "Є ПОДОРОЖІ ЯКІ СТВОРЮЄШ ТИ",
        group_tour_subtitle: "А Є ПОДОРОЖІ ЯКІ СТВОРЮЮТЬ ТЕБЕ",
        group_tour_subtitle_text: "Наші тури створені так, щоб розкрити справжню сутність кожного місця, дозволяючи вам повністю зануритися в його атмосферу. Ми подбали про всі деталі — від транспорту та проживання до насиченої програми, щоб ваша подорож була легкою та безтурботною.\n" +
            "\n" +
            "Завдяки місцевим гідам, які знають кожен куточок, ви відкриєте для себе більше, ніж просто популярні пам’ятки, і отримаєте глибше розуміння культури та історії. Невеликі групи забезпечують комфортну та гнучку подорож, дозволяючи вам досліджувати нові місця у власному ритмі.\n" +
            "\n" +
            "Усе вже включено у вартість — транспорт, вхідні квитки та страхування, тож ви можете просто насолоджуватися пригодою. До того ж, ви подорожуватимете разом із однодумцями, створюючи незабутні спогади та нові дружні зв’язки.\n" +
            "\n" +
            "Наші групові тури — це ідеальне поєднання комфорту, пригод та натхненних зустрічей, що зроблять вашу подорож справді особливою.",

        gallery_title: "ВІДКРИВАЙ СВІТ НАШИМИ ОЧИМА",
        gallery_subtitle: "Фотографії з наших подорожей.",

        day1: "День 1",
        day2: "День 2",
        day3: "День 3",
        day4: "День 4",
        day5: "День 5",
        day6: "День 6",
        day7: "День 7",

        way_title: 'Coming soon...',
        way_subtitle: '',


        //georgia
        georgia: "Грузія",
        georgia_price: '£850',
        georgia_date: '23–30 березня',
        georgia_date_calendar: '2025-03-25',

        georgia_description_title: "Серце Кавказу",
        georgia_descriptions: [
            "Відкрий для себе два чарівні світи, сповнені краси, тепла та давніх традицій. У Грузії прогулюйся затишними вуличками Тбілісі, милуйся захопливими краєвидами величних гір Казбегі та насолоджуйся знаменитою грузинською кухнею і вином — одним із найстаріших у світі. В Вірменії тебе зачарують сині води озера Севан, вічна краса храму Гарні та енергія Єревана — міста, де історія зустрічається з сучасністю. Ця подорож — ідеальне поєднання природи, культури та натхнення від двох унікальних країн.",
        ],

        georgia_img1: "Озера",
        georgia_img2: "Старе місто",
        georgia_img3: "Дегустація вина",
        georgia_img4: "Традиційна кухня",
        georgia_img5: "Музеї",
        georgia_img6: "Архітектурні памʼятки",

        georgia_d1: 'Прибуття',
        georgia_activity_d1: [
            '• Прибуття до Грузії',
            '• Трансфер до готелю (приблизно 30 хвилин)',
            '• Заселення в готель',
            '• Відпочинок у готелі',
            '• Вільний час',
            '• Прогулянка Старим Тбілісі',
            '• Традиційна грузинська вечеря (Супра)',
        ],

        georgia_d2: 'Тур до Казбегі',
        georgia_activity_d2: [
            '• Жинвальське водосховище',
            '• Фортеця Ананурі',
            '• Курорт Гудаурі та Арка Дружби',
            '• Степанцмінда (Казбегі) та церква Святої Трійці в Гергеті',
        ],

        georgia_d3: 'Тбілісі',
        georgia_activity_d3: [
            '• Дослідження вулиць Сололаки, фотозони та архітектура.',
            '• Візит до мавританського будинку, особняка Берії та відомих будівель.',
            '• Прогулянка районом Абанотубані, знайомство з історією Тбілісі.',
            '• Відвідування водоспаду в центрі міста.',
            '• Театр маріонеток Габріадзе, Міст Миру, вулиця Шардені.',
            '• Знайомство з традиціями грузинських застіль від Тамади.',
            '• Дегустація вин у винному льосі XVII століття.',
            '• Фортеця Нарікала, статуя «Мати Грузії».',
            '• Фрески «Хроніки Грузії».',
        ],

        georgia_d4: 'Мцхета & Переїзд до Вірменії',
        georgia_activity_d4: [
            '• Відвідування монастиря Джварі.',
            '• Легенди та історія першого хреста.',
            '• Огляд кафедрального собору Светіцховелі та історії Мцхети.',
            '• Відвідування монастиря Самтавро.',
            '• Переїзд до Вірменії (Єреван) – приблизно 5-7 годин.',
            '• Заселення в готель у Єревані.',
        ],

        georgia_d5: 'Озеро Севан & Єреван',
        georgia_activity_d5: [
            '• Дорога до Вірменії (приблизно 5 годин).',
            '• Відвідування озера Севан з його кришталево чистими водами.',
            '• Дослідження монастиря Айраванк.',
            '• Прибуття до Єревана – столиці Вірменії.',
        ],

        georgia_d6: 'Гарні & Симфонія Каменів & Єреван',
        georgia_activity_d6: [
            '• Екскурсія до історичного храму Гарні.',
            '• Прогулянка Єреваном.',
            '• Останній вечір у місті, що залишає незабутні враження.',
        ],

        georgia_d7: 'Дорога додому',
        georgia_activity_d7: [
            '• Трансфер до аеропорту.',
            '• Від’їзд і прощання з цими прекрасними країнами.',
        ],


        georgia_program_d1: [
            'Після прибуття до Грузії ми зустрінемо тебе в аеропорту та доставимо до готелю, що всього за 30 хвилин їзди. Після заселення у тебе буде час відпочити та освоїтися. Насолодись традиційним грузинським сніданком у готелі, а потім – вільний час для розслаблення. Обід проходитиме у ресторані Chveni, де ти скуштуєш справжні грузинські страви. Далі ми вирушимо на прогулянку історичними вуличками Старого Тбілісі, милуючись архітектурою та атмосферою міста. Ввечері на тебе чекає особлива вечеря – традиційна грузинська supra, організована родиною виноробів та кухарів. Ти познайомишся з місцевими кулінарними традиціями, навчишся мистецтву тостів та відкриєш для себе унікальну культуру грузинського застілля, насолоджуючись смачними стравами та гостинністю господарів.'
        ],

        georgia_program_d2: [
            'Другий день розпочнеться з поїздки до мальовничого Жинвальського водосховища, що оточене горами. За бажанням можна покататися на човні по його бірюзових водах. Далі ми відвідаємо фортецю Ананурі, де ти зможеш оглянути старовинні церкви та вежі з панорамним видом на водосховище.',
            'Наступна зупинка – гірський курорт Гудаурі та Арка Дружби, звідки відкриваються приголомшливі краєвиди на гори та долини. Потім ми вирушимо до Степанцмінди (Казбегі), щоб відвідати церкву Святої Трійці в Гергеті, що розташована на схилі з вражаючими краєвидами на гору Казбек.',
            'Завершиться день мальовничою кінною прогулянкою у горах Казбегі та відпочинком біля річки Арагві, де можна повністю зануритися в природну красу регіону.',
        ],

        georgia_program_d3: [
            'Третій день присвячений дослідженню історичних районів Тбілісі. Ми прогуляємося затишними вуличками Сололаки, відвідавши знакові місця, такі як мавританський будинок та особняк Берії.',
            'Далі ми вирушимо в район Абанотубані, щоб дізнатися більше про історію міста та побачити водоспад у центрі Тбілісі. Потім ми відвідаємо театр маріонеток Габріадзе, Міст Миру та вулицю Шардені.',
            'Також ми познайомимося з традиціями грузинських застіль разом із Тамадою та завітаємо до винного льоху XVII століття на дегустацію вина. Завершимо день у фортеці Нарікала, біля статуї «Мати Грузії», та оглянемо монументальні фрески «Хроніки Грузії».',
        ],

        georgia_program_d4: [
            'Четвертий день почнеться з відвідування монастиря Джварі, де ми поговоримо про його історію, перший хрест, встановлений святою Ніно та царем Міріаном, і помилуємося панорамним видом на злиття річок,.',
            'Потім ми вирушимо до кафедрального собору Светіцховелі у Мцхеті, щоб дізнатися про його значення, адже тут зберігається хитон Христа та мощі святого Андрія.',
            'Далі нас чекає монастир Самтавро – один із найдавніших у Грузії, де поховані перші християнські правителі країни та росте чудотворна ожина святого Гавриїла.',
            'Після цього ми перетнемо кордон і вирушимо до Єревана, столиці Вірменії.',
        ],

        georgia_program_d5: [
            'Після сніданку ми вирушимо у Вірменію. По дорозі ти побачиш мальовниче озеро Севан з його кришталево чистими водами та відвідаєш старовинний монастир Айраванк. До вечора ми прибудемо в Єреван – місто, що зачаровує своєю атмосферою та гостинністю.',
        ],

        georgia_program_d6: [
            'День розпочнеться з екскурсії до стародавнього язичницького храму Гарні. Після цього у тебе буде можливість прогулятися затишними вулицями Єревана, відкрити для себе приховані дворики та відчути унікальний дух вірменської культури.',
        ],

        georgia_program_d7: [
            'З теплими спогадами, чарівними краєвидами Кавказьких гір та гостинністю Грузії та Вірменії настав час повертатися додому. Ця подорож неодмінно залишить у серці незабутній слід.',
        ],


        georgia_hotel_title: 'Твій комфорт – наш пріоритет',
        georgia_hotel_text: [
            'У Грузії та Вірменії ми зупинятимемося у ретельно відібраних готелях, які забезпечують комфорт та затишну атмосферу. Хоча фотографії на сайті можуть не повністю відповідати вибраним готелям, будь певен/а – вони будуть дуже схожими або навіть тими ж самими. Ми особисто підбираємо місця проживання, щоб твоя подорож була максимально комфортною та приємною.',
            'Також зверни увагу, що розміщення буде у спільних номерах із людьми однієї статі, максимум по троє осіб у кімнаті, щоб забезпечити приємну та зручну атмосферу під час подорожі.',
        ],

        georgia_price_included: [
            '• Проживання',
            '• Сніданки.',
            '• Трансфер з/до аеропорту.',
            '• Комфортні переїзди між локаціями.',
            '• Зворотний трансфер до аеропорту.',
            '• Верхова їзда мальовничими ландшафтами.',
            '• Майстер-клас із приготування традиційного хачапурі.'
        ],

        georgia_price_not_included: [
            '• Харчування (якщо не вказано в програмі).',
            '• Авіаперельоти до/з місця призначення.'
        ],

        //lofoten
        lofoten: "Лофотенські острови",
        lofoten_price: '£795',
        lofoten_date: '8-12 вересня',
        lofoten_date_calendar: '2025-09-08',

        lofoten_description_title: "Під небом Лофотен: подорож у край фіордів",
        lofoten_descriptions:
            [
                "За Полярним колом розташовані Лофотенські острови – край величних гір, прозорих фіордів і затишних рибальських селищ. Від пішого підйому на Рейнебрінген до спокійного каякінгу чи розслаблення в традиційній сауні – Лофотен пропонує ідеальне поєднання пригод і спокою. Досліджуйте історію вікінгів, смакуйте свіжі морепродукти та насолоджуйтеся неймовірною красою цього незабутнього місця."
            ],

        lofoten_img1: "Піший підйом",
        lofoten_img2: "Норвезька кухня",
        lofoten_img3: "Каякінг",
        lofoten_img4: "Сауна",
        lofoten_img5: "Фіорди",
        lofoten_img6: "Музеї",


        lofoten_activity_d1: [
            '• Прибуття в Бодо',
            '• Трансфер поромом до Москенеса',
            '• Заселення',
        ],

        lofoten_activity_d2: [
            '• Піший підйом на Рейнебрінген 1,1 км',
            '• Хамной, склодувна майстерня Glass Vikten AS',
            '• Пляж Квалвік',
            '• Фредванг',
            '• Вечеря в курортному комплексі Nusfjord',
            '• Повернення до апартаментів',
        ],
        lofoten_activity_d3: [
            '• Міст Флакстадбрюене',
            '• Музей вікінгів Lofotr (за бажанням)',
            '• Ферма Aalan Gard',
            '• Каякінг на заході сонця (за бажанням)',
            '• Вечеря',
            '• Повернення до апартаментів',
        ],
        lofoten_activity_d4: [
            '• Верхова їзда в Hov Horge',
            '• Ресторан Børsen Spiseri',
            '• Льодовий бар Magic Ice Lofoten',
            '• Сауна (за бажанням)',
            '• Вечеря',
            '• Повернення до апартаментів',
        ],
        lofoten_activity_d5: [
            '• Сніданок',
            '• Прощання з Лофотенськими Островами',
        ],

        lofoten_d1: 'Прибуття',
        lofoten_d2: 'Рейнебрінген, Хамной і краса узбережжя',
        lofoten_d3: 'Історія вікінгів і каякінг на заході сонця',
        lofoten_d4: 'Верхова їзда та прощальна вечеря',
        lofoten_d5: 'Від’їзд',

        lofoten_program_d1: [
            'Ми приземлимося в Бодо і, якщо дозволить час, трохи дослідимо місто перед тим, як сісти на пором до Москенеса. Саме плавання стане окремою пригодою, адже відкриються неймовірні краєвиди на море та навколишні гори. Після прибуття ми заселимося в апартаменти, повечеряємо та відпочинемо.'
        ],
        lofoten_program_d2: [
            'Ми розпочнемо день із походу на вершину Рейнебрінгена (1,1 км), звідки відкриваються захопливі краєвиди фіордів. Далі відвідаємо мальовниче селище Хамной, а потім зазирнемо до Glass Vikten AS, де побачимо, як працюють склодуви, та зможемо придбати їхні унікальні вироби. Після цього вирушимо до спокійного пляжу Квалвік і Фредванга, щоб помилуватися його знаменитими мостами. Після вечері повернемося на відпочинок.'
        ],
        lofoten_program_d3: [
            'День розпочнеться з подорожі через мости Флакстадбрюне, насолоджуючись чудовими краєвидами. Першою зупинкою стане музей вікінгів Лофотр, де ми поринемо в атмосферу скандинавської історії. Потім відвідаємо ферму Aalan Gard, відому своїми органічними козячими сирами. Увечері нас чекає каякінг на заході сонця – ідеальний спосіб побачити узбережжя Лофотенських островів. Завершимо день вечерею в одному з місцевих ресторанів.'
        ],
        lofoten_program_d4: [
            'Останній повноцінний день подорожі розпочнеться з кінної прогулянки в Хов Хорге – чудової нагоди насолодитися природою. На обід скуштуємо традиційні страви Лофотенських островів у ресторані Børsen Spiseri. Після цього відвідаємо футбольне поле в Хеннінгсвері – одне з найкрасивіших у світі, оточене приголомшливими краєвидами. Потім вирушимо до льодового бару Magic Ice Lofoten, де зможемо помилуватися крижаними скульптурами та випити коктейль. Перед поверненням додому розслабимося в сауні, повечеряємо та насолодимося останнім вечором у Лофотені.'
        ],
        lofoten_program_d5: [
            'Після заключного сніданку виселяємося з готелю та прямуємо до порту Москенес, звідки на поромі повертаємося до Бодо. Далі вирушаємо додому, забираючи з собою незабутні спогади про цю подорож.'
        ],

        lofoten_hotel_text: [
            'На Лофотенських островах ми проживатимемо в ретельно відібраних апартаментах, що забезпечать комфорт і затишок. Хоча фотографії на сайті можуть трохи відрізнятися від реальних помешкань, будьте певні – вони будуть максимально схожими або такими самими. Ми ретельно підбираємо місця для проживання, щоб зробити вашу подорож комфортною та приємною.',
            'Зверніть увагу, що розміщення в кімнатах передбачене з іншими учасниками тієї ж статі, максимум по троє осіб у кімнаті, що забезпечує комфортну та дружню атмосферу під час подорожі.'
        ],

        lofoten_price_included: [
            '• Проживання',
            '• Трансфери до та з аеропорту',
            '• Трансфери між локаціями',
            '• Пором з Бодо до Лофотенських островів і назад',
            '• Екскурсії з гідом',
            '• Туристичне страхування (базовий пакет)'
        ],

        lofoten_price_not_included: [
            '• Авіаквитки',
            '• Харчування (ми підберемо доступні ресторани та кафе, а також за можливості готуватимемо разом в апартаментах)',
            '• Музей вікінгів – £20',
            '• Каякінг на заході сонця – £100',
            '• Кінна прогулянка – £110',
            '• Льодовий бар Magic Ice Lofoten – £25',
            '• Сауна – £50'
        ],

        lofoten_essential_title: 'Essential Items for a Summer Adventure in Lofoten',

        //norway
        norway: "Норвегія",
        norway_price: '£890',
        norway_date: '17-22 червня',
        norway_date_calendar: '2025-06-17',

        norway_description_title: "Легенди фіордів",
        norway_descriptions: [
            "Досліджуйте драматичні ландшафти Норвегії – від величних скель і водоспадів до кришталево чистих озер і давніх льодовиків. Пройдіть захопливі маршрути, відвідайте історичні місця вікінгів і насолодіться красою Бергена.",
        ],

        norway_img1: "Язик Троля",
        norway_img2: "Долина вікінгів",
        norway_img3: "Льодовики",
        norway_img4: "Каякінг",
        norway_img5: "Берген",
        norway_img6: "Сауна",

        norway_activity_d1: [
            '• Прибуття до Норвегії',
            '• Заселення в апартаменти',
        ],

        norway_activity_d2: [
            '• Похід на Язик Троля (10–12 годин)',
            '• Досвід традиційної сауни (за бажанням)',
        ],
        norway_activity_d3: [
            '• Похід до водоспаду Вьорінгфоссен',
            '• Занурення в атмосферу Долини вікінгів',
            '• Відвідування оглядового майданчика Стегастейн (за умови наявності часу)',
        ],
        norway_activity_d4: [
            '• Льодовик Йостедальсбрін',
            '• Озеро Ловатнет',
            '• Каякінг (за бажанням)',
        ],
        norway_activity_d5: [
            '• Повернення до Бергена (приблизно 4 години їзди)',
            '• Дослідження Бергена',
        ],
        norway_activity_d6: [
            '• Сніданок у Бергені (за умови наявності часу)',
            '• Від’їзд',
        ],

        norway_d1: 'Прибуття',
        norway_d2: 'Похід на Язик Троля та сауна',
        norway_d3: 'Вьорінгфоссен, Долина вікінгів та переїзд',
        norway_d4: 'Льодовик Йостедальсбрін та озеро Ловатнет',
        norway_d5: 'Повернення до Бергена та прогулянка містом',
        norway_d6: 'Прощання та від’їзд',

        norway_program_d1: [
            'Наша подорож починається з прибуття до Норвегії. Це буде спокійний день, щоб ми могли заселитися, розташуватися в нашому житлі та підготуватися до майбутніх пригод. Ми також придбаємо необхідні запаси, зокрема снеки та їжу на наступний день, щоб бути добре підготовленими до викликів, які чекають попереду.'
        ],
        norway_program_d2: [
            'Ми розпочнемо день рано, оскільки похід на Язик Троля є вимогливим, але дуже захопливим досвідом, що триває приблизно 10-12 годин. Після ситного сніданку в нашому житлі ми вирушимо в похід із заздалегідь підготовленими ланчами. Хоча маршрут досить складний, краєвиди, що відкриваються з вершини, роблять кожен крок вартий зусиль. Після повернення буде можливість розслабитися в сауні – це повністю за бажанням, але стане чудовим способом відпочити після насиченого дня.'
        ],
        norway_program_d3: [
            'Ранок почнеться з походу до водоспаду Вьорінгфоссен – одного з найкрасивіших у Норвегії. Далі ми поринемо в атмосферу минулого, відвідавши Долину вікінгів, де нас чекатиме традиційна вечеря у стилі вікінгів. Якщо дозволить час, ми також відвідаємо оглядовий майданчик Стегастейн, перш ніж вирушити до нашого наступного житла.'
        ],
        norway_program_d4: [
            'Сьогодні ми вирушимо до найбільшого льодовика Норвегії – Йостедальсбріна, де зможемо помилуватися його величними пейзажами зблизька. Після цього ми відвідаємо чарівне озеро Ловатнет. Тут буде можливість зайнятися каякінгом – чудовим способом насолодитися навколишньою красою.'
        ],
        norway_program_d5: [
            'Ми вирушимо назад до Бергена, що займе приблизно чотири години, і проведемо день, досліджуючи це яскраве місто. Від його затишних вуличок до багатої культурної спадщини – Берген стане ідеальним місцем для завершення нашої подорожі. Цього вечора ми залишимося в нашому останньому житлі, насолоджуючись фінальною вечерею перед завтрашнім від’їздом.'
        ],
        norway_program_d6: [
            'Наша подорож добігає кінця, і настав час прощатися. Після незабутніх пригод ми роз’їдемося по домівках, забравши із собою спогади про вражаючі ландшафти, історію та унікальні враження Норвегії.'
        ],

        norway_hotel_title: 'Проживання',
        norway_hotel_text: [
            'У Норвегії ми будемо зупинятися в ретельно відібраних місцях, які забезпечать комфортне та затишне перебування. Хоча фотографії на сайті можуть не повністю відповідати нашим помешканням, будьте певні – вони будуть дуже схожі, якщо не ті самі. Ми з великою увагою підходимо до вибору кожної локації, щоб ваш відпочинок був максимально комфортним і приємним.',
            'Зверніть увагу, що номери будуть спільними для осіб однієї статі, з максимум трьома людьми в кімнаті, що забезпечить приємну та комфортну атмосферу під час усього перебування.'
        ],

        norway_price_included: [
            '• Проживання',
            '• Трансфери до та з аеропорту',
            '• Трансфери між локаціями',
            '• Автобус до парковки Язика Троля де розпочнеться маршрут та плата за паркування',
            '• Вечеря у стилі вікінгів',
            '• Туристичне страхування (базовий тариф)',
        ],

        norway_price_not_included: [
            '• Авіаквитки',
            '• Харчування (ми ретельно підберемо доступні ресторани та кафе, а коли буде можливість, готуватимемо разом в наших апартаментах)',
            '• Каякінг - £75',
            '• Сауна - £25',
        ],

        nordic_essential_items: [
            ' • Водонепроникна куртка та штани',
            ' •	Теплі шари одягу (термобілизна, светри, флісові кофти)',
            ' •	Шапка, рукавички та шарф (навіть улітку може бути прохолодно)',
            ' •	Міцні водонепроникні черевики для прогулянок',
            ' •	Сонцезахисний крем',
            ' •	Бальзам для губ із SPF (вітер може сушити шкіру)',
            ' •	Купальник',
            ' •	Сонцезахисні окуляри',
            ' •	Багаторазова пляшка для води',
            ' •	Рюкзак',
            ' •	Персональні ліки за рецептом (знеболювальні, антигістаміни, таблетки від захитування)',
            ' •	Аптечка першої допомоги (пластирі, антисептичні серветки тощо)',
            ' •	Необхідні ліки від алергії',
        ],

        // italy como
        italy: "Італія Комо",
        italy_como: "Озеро Комо",
        italy_como_price: '£645',
        italy_como_date: '3-6 Липня',
        italy_como_date_calendar: '2025-07-03',

        italy_como_description_title: "За межами блакитних вод",
        italy_como_descriptions: [
            'Відкрийте для себе красу Північної Італії – від знаменитих пам’яток Мілана до мальовничих сіл озера Комо. Відчуйте шарм Белладжіо та Варенни, насолоджуйтеся захопливими прогулянками на човнах і відкривайте для себе вражаючі вілли, занурюючись у багату культуру та неймовірні краєвиди цього регіону.'
        ],

        italy_como_img1: "VILLA BALBIANELLO",
        italy_como_img2: "BOAT TOUR",
        italy_como_img3: "ITALIAN CUISINE ",
        italy_como_img4: "MILAN",
        italy_como_img5: "BELLAGIO",
        italy_como_img6: "VARENNA",

        italy_como_activity_d1: [
            '• Прибуття до Мілана',
            '• Огляд визначних місць Мілана (Дуомо, Галерея Вітторіо Емануеле II, район Брера)',
            '• Заселення в готель (Комо)',
        ],

        italy_como_activity_d2: [
            '• Відвідування Вілли Бальбьянелло',
            '• Прогулянка Тремеццо (Вілла Карлотта)',
            '• Белладжіо',
        ],

        italy_como_activity_d3: [
            '• Приватна прогулянка на човні',
            '• Фотосесія (за бажанням)',
            '• Відвідування Вілли Монастеро',
            '• Прогулянка у Варенні',
        ],

        italy_como_activity_d4: [
            '• Фінальний сніданок',
            '• Прощання з Італією',
        ],

        italy_como_d1: 'Прибуття та прогулянка Міланом',
        italy_como_d2: 'Відкриття перлин озера Комо',
        italy_como_d3: 'Подорож на човні та культурні пам\'ятки',
        italy_como_d4: 'Прощання та від’їзд',

        italy_como_program_d1: [
            'Ми приїдемо до Мілана і розпочнемо нашу подорож. Перший день ми присвятимо прогулянці по найвідоміших пам\'ятках міста, від захоплюючого Дуомо до елегантної Галереї Вітторіо Емануеле II та чарівних вуличок Брери. Ввечері ми зберемося на смачну групову вечерю перед тим, як поїхати в наш готель біля озера Комо для заселення і відпочинку.'
        ],
        italy_como_program_d2: [
            'Ми почнемо день з відвідування Вілли Бальбьянелло – чудового історичного маєтку, що розташований на березі озера. Далі ми вирушимо до мальовничого містечка Тремеццо, де знаходиться чарівний сад Вілли Карлотта. Насолодившись красою навколишнього середовища, ми сядемо на паром до Белладжіо, яке часто називають "Перлиною озера Комо", де прогуляємося по вуличках і насолодимося обідом з захоплюючим видом на озеро.'
        ],
        italy_como_program_d3: [
            'Ми вирушимо на приватну прогулянку на човні, насолоджуючись величними пейзажами. Для тих, хто бажає, буде доступна додаткова фотосесія, щоб зафіксувати магію нашої подорожі. Потім ми відвідаємо Віллу Монастеро, віллу на березі озера з чудовими садами та панорамними видами. Наша подорож продовжиться в мальовничому містечку Варенна, де ми зможемо розслабитися, прогулятися та насолодитися спокійною атмосферою цього ідилічного місця.'
        ],
        italy_como_program_d4: [
            'Вранці нашого останнього дня ми зберемося на сніданок, згадуючи незабутні миті нашої подорожі. Зі сповненими серцями і камерами, наповненими спогадами, ми вирушимо додому, забираючи з собою красу та магію озера Комо.'
        ],


        italy_como_hotel_title: 'Проживання',
        italy_como_hotel_text:
            [
                'Ми будемо проживати в ретельно обраному готелі, який надає гостинну та комфортну атмосферу. Хоча фотографії на сайті можуть не точно відповідати місцю нашого проживання, вони будуть дуже схожі, якщо не ідентичні. Ми обираємо готелі, які поєднують якість і шарм, забезпечуючи приємне перебування для кожного учасника групи.',
                'Номери будуть розділені між особами однієї статі, з максимальною кількістю три людини в номері. Це забезпечить комфортну атмосферу, що дозволить кожному розслабитися та насолоджуватися часом у чудових краєвидах озера Комо.',
            ],

        italy_como_price_included: [
            '• Готель',
            '• Трансфери до та з аеропорту',
            '• Трансфери між локаціями',
            '• Квиток до Вілли Бальбьянелло',
            '• Квиток до Вілли Монастеро',
            '• Подорож на човні',
        ],

        italy_como_price_not_included: [
            '• Квитки на літак',
            '• Харчування (обіди та вечері)',
            '• Фотосесія  £100. Кожен учасник отримає персональну 30-хвилинну сесію в рамках групової подорожі.',
        ],

        italy_como_essential_items: [
            '•  Зручне взуття для прогулянок',
            '•  Легкі шари одягу та водонепроникна куртка для різних погодних умов',
            '•  Сонцезахисні окуляри, капелюх та сонцезахисний крем',
            '•  Маленький рюкзак або сумка через плече для денних поїздок',
            '•  Купальник',
        ],

        // iceland
        iceland: "Ісландія",
        iceland_price: '£1065',
        iceland_date: '2-7 червня',
        iceland_date_calendar: '2025-06-02',

        iceland_description_title: "Край полум'я та криги",
        iceland_descriptions: [
            "Почніть свою подорож Ісландією, досліджуючи вражаючі ландшафти цієї країни: величезні водоспади, величезні льодовики, вулканічні рівнини та пляжі з чорним піском. Відвідайте приголомшливі природні чудеса, включаючи знамените водоспад Гуллфосс і сховані водоспади Глюфрабуї, загадкові руїни літака на пляжі Солхеймасанур, та яскраву геотермальну красу Ландманналаугара. Ця пригода подарує незабутні враження від дикої краси Ісландії, де кожен мандрівник знайде частинку себе."
        ],

        iceland_img1: "СПОСТЕРЕЖЕННЯ ЗА КИТАМИ",
        iceland_img2: "БЛАКИТНА ЛАГУНА",
        iceland_img3: "ПОДОРОЖІ НА КОЛЕСАХ",
        iceland_img4: "РУЇНИ ЛІТАКА СО́ЛХЕЙМАСАНДУР",
        iceland_img5: "РЕЙК’ЯВІК",
        iceland_img6: "ДИКІ ТВАРИНИ",

        iceland_activity_d1: [
            'Прибуття в Ісландію',
            'Заселення в готель',
        ],

        iceland_activity_d2: [
            'Гуллфосс',
            'Глюфрабуї (водоспад)',
            'Руїни літака Солхеймасанур',
            'Пляж Рейнісф’яра (чорний пісок)',
        ],

        iceland_activity_d3: [
            'Похід до Тьорсмьорка (8-10 годин)',
        ],
        iceland_activity_d4: [
            'Льодовик Мірдалсйокутль',
            'Похід до Ландманналаугара (30-40 хвилин)',
            'Хайфосс',
            'Гвітарватн',
        ],
        iceland_activity_d5: [
            'Рейк’явік',
            'Спостереження за китами (за бажанням)',
            'Блакитна лагуна (за бажанням)',
        ],
        iceland_activity_d6: [
            'Сніданок в Рейк’явіку (якщо дозволяє час)',
            'Прощання з Ісландією',
        ],

        iceland_d1: 'Прибуття',
        iceland_d2: 'Водоспади, чорні піски та руїни літака',
        iceland_d3: 'Похід до Тьорсмьорка',
        iceland_d4: 'Льодовики, високогір’я та водоспади',
        iceland_d5: 'Рейк’явік, спостереження за китами та Блакитна лагуна',
        iceland_d6: 'Прощання з Ісландією',

        iceland_program_d1: [
            'Ми прибуваємо до Ісландії та заселяємося в наш готель, відпочиваючи перед тим, як наша подорож почнеться.'
        ],
        iceland_program_d2: [
            'Ми розпочнемо нашу пригоду з відвідування вражаючого водоспаду Гуллфосс, одного з найпотужніших водоспадів Ісландії. Потім ми відправимося до схованого водоспаду Глюфрабуї, що прихований за каньйоном. Далі ми здійснимо похід до руїн літака Солхеймасанур, де залишки американського військового літака лежать на чорному піску. Завершимо день на пляжі Рейнісф’яра, відомому своїми базальтовими колоннами та сильними хвилями Атлантики.'
        ],
        iceland_program_d3: [
            'Сьогодні ми вирушимо на одноденний похід (8-10 годин) по Тьорсмьорку – долини, оточеній льодовиками, річками та скелястими піками. Протягом подорожі ми будемо переходити річки, долати зелені долини та насолоджуватися захоплюючими гірськими пейзажами. Це один з найкращих хайкінгових маршрутів Ісландії, і по його завершенню ми зможемо насолодитися неймовірною красою цієї країни.'
        ],
        iceland_program_d4: [
            'Ми розпочнемо день з відвідування льодовика Мірдалсйокутль, одного з найвражаючих льодовиків Ісландії, де відкривається неймовірний вид на замерзлу пустку. Далі ми вирушимо до Ландманналаугара, відомого своїми кольоровими гірськими масивами, де здійснимо короткий похід (30-40 хвилин) та помилуємося іншсвітними краєвидами. Після цього ми відвідаємо Хайфосс, один з найвищих водоспадів Ісландії, висотою 122 метри. Остання зупинка – Гвітарватн, льодовикове озеро з чудовими відображеннями гір.'
        ],
        iceland_program_d5: [
            'Ми проведемо день, досліджуючи Рейк’явік, занурюючись у його культуру, архітектуру та яскраву атмосферу. Також є можливість відправитися на екскурсію з спостереженням за китами, де ми зможемо побачити кілька видів китів, включаючи мінке, горбатих або навіть косаток у дикій природі. Пізніше, для тих, хто хоче розслабитися, можна відвідати Блакитну лагуну, насолоджуючись теплими мінеральними водами, оточеними лавовими полями.'
        ],
        iceland_program_d6: [
            'Ми насолоджуємося останнім сніданком (якщо час дозволяє) у Рейк’явіку, отримуючи останні миті нашої подорожі перед тим, як вирушити в аеропорт. Час прощатися з цією чудовою країною, але спогади залишаться з нами назавжди.'
        ],

        iceland_hotel_title: 'Проживання',
        iceland_hotel_text:
            [
                'В Ісландії ми зупинимось у ретельно обраних місцях, що забезпечують комфортну та затишну атмосферу. Хоча фотографії на сайті можуть не точно відповідати місцям нашого проживання, вони будуть дуже схожі, якщо не ідентичні. Ми ретельно обираємо кожен готель, щоб ваш відпочинок був максимально комфортним і приємним.',
                'Також зверніть увагу, що номери будуть поділені між особами однієї статі, з максимальною кількістю три людини в номері, що забезпечує приємну та поважну атмосферу під час вашого перебування.',
            ],

        iceland_price_included: [
            '• Проживання',
            '• Трансфери до та з аеропорту',
            '• Трансфери між локаціями',
            '• Екскурсії до місць',
            '• Туристичне страхування (базовий пакет)',
        ],

        iceland_price_not_included: [
            '• Авіаквитки',
            '• Харчування (ми ретельно підберемо доступні ресторани або кафе, а також, де це можливо, готуватимемо разом їжу в наших апартаментах)',
            '• Блакитна лагуна - £100',
            '• Спостереження за китами - £85',
        ],


        // portugal
        portugal: "Португалія",
        portugal_price: '£950',
        portugal_date: '15-20 Липня',
        portugal_date_calendar: '2025-07-15',
        portugal_description_title: "Хвилі та Дива Португалії",
        portugal_descriptions:
            ["Приєднуйтесь до нас на незабутню подорож до Португалії, де ви проведете шість днів, серфінгуючи з досвідченими інструкторами, досліджуючи захоплюючі місця, такі як Лісабон, Порто та Сінтра, і насолоджуючись смачною португальською кухнею.",
                "Незалежно від того, чи хочете ви покращити свої навички, чи просто насолодитися атмосферою, ви завести нових друзів, створите незабутні спогади і проведете час, який запам'ятається на все життя. Побачимось на хвилях!",
            ],

        portugal_img1: "Відвідайте Порто",
        portugal_img2: "Серфінг",
        portugal_img3: "Відвідайте Назаре",
        portugal_img4: "Відвідайте Лісабон",
        portugal_img5: "Відвідайте Сінтру",
        portugal_img6: "Йога",


        portugal_activity_d1: [
            '• Прибуття',
            '• Вечеря-знайомство',
            '• Йога'
        ],

        portugal_activity_d2: [
            '• Сніданок',
            '• Урок серфінгу',
            '• Поїздка в Назаре',
            '• Йога',
        ],
        portugal_activity_d3: [
            '• Сніданок',
            '• Урок серфінгу',
            '• Вільний час',
            '• Велосипедна екскурсія',
            '• Зустріч групи',
            '• Йога',
        ],
        portugal_activity_d4: [
            '• Сніданок',
            '• Урок серфінгу',
            '• Поїздка в Лісабон',
            '• Йога',
        ],

        portugal_activity_d5: [
            '• Сніданок',
            '• Урок серфінгу',
            '• Поїздка в Порто',
            '• Дослідження нічного життя',
        ],
        portugal_activity_d6: [
            '• Сніданок',
            '• Урок серфінгу',
            '• Прощання',
        ],

        portugal_activity_additional_info: "Уроки серфінгу та заняття йогою є необов'язковими — ви самі вирішуєте, як сформувати своє перебування!",

        portugal_d1: 'Ласкаво просимо до Португалії!',
        portugal_d2: 'Перші хвилі та дослідження Назаре',
        portugal_d3: 'Серфінг, дослідження та спілкування',
        portugal_d4: 'Серфінг та відкриття Лісабону',
        portugal_d5: 'Серфінг та магія Порто',
        portugal_d6: 'Останній заїзд та прощання',

        portugal_program_d1: [
            'Приїжджаєте та оселяєтесь у своєму новому домі на наступні шість днів. Ввечері ми пригощаємо вас смачною привітальною вечерею, де ви зможете познайомитись з іншими учасниками. Після цього ви зможете розслабитись на необов\'язковому заході йоги на заході сонця.'
        ],
        portugal_program_d2: [
            'Почніть день з ситного сніданку, а потім вирушайте на пляж на перший урок серфінгу. Незалежно від того, чи є у вас досвід, наші кваліфіковані інструктори будуть вас супроводжувати. Після деякого часу у воді ми вирушимо в Назаре, знаменитий своїми рекордними хвилями та захоплюючими прибережними видами. Потім ми поїдемо до Сінтри, чарівного міста, відомого своїми казковими палацами, зеленими лісами та вражаючими пейзажами. Прогуляємось його чарівними вуличками, дослідимо знакові пам\'ятки, такі як Палац Пени, і насолодимось містичною атмосферою, перш ніж повернутися для заслуженого відпочинку.'
        ],
        portugal_program_d3: [
            'Ще один енергійний ранок починається зі сніданку та необов\'язкового уроку серфінгу. Далі ви можете насолоджуватися вільним часом — розслаблятись біля океану, досліджувати околиці або просто відновлювати сили. Потім ми вирушимо на велосипедну екскурсію, щоб відкрити приховані скарби, а пізніше відбудеться зустріч групи, де ми будемо ділитися історіями, сміхом та, можливо, деякими сюрпризами. Закінчимо день на необов\'язковому занятті йогою, щоб розслабитись.'
        ],
        portugal_program_d4: [
            'Зарядимось на сніданку перед ще одним захоплюючим уроком серфінгу. Потім вирушимо в Лісабон — яскраву столицю Португалії, де старовинний шарм поєднується з сучасною енергією. Прогуляємось історичними вулицями, відвідаємо знамениті пам\'ятки і поринемо в атмосферу міста. Коли настане вечір, ви матимете можливість розслабитись на занятті йогою або зануритись у вир нічного життя міста.'
        ],
        portugal_program_d5: [
            'Після сніданку та ще одного уроку серфінгу ми вирушимо в Порто — місто, відоме своїм чудовим набережним, затишним старим містом та знаменитим портвейном. Прогуляємось живими вулицями, насолодимось захоплюючими видами та відчуємо енергію міста. В залежності від настрою, ми можемо провести ніч, досліджуючи нічне життя Порто.'
        ],
        portugal_program_d6: [
            'Насолодимось сніданком з групою перед  уроком серфінгу (якщо ви хочете). Незалежно від того, чи це були хвилі, нові знайомства чи досвід, ви будете наповнені з спогадами, які залишаться з вами на все життя.'
        ],


        portugal_hotel_title: 'Ваш комфорт — наш пріоритет',
        portugal_hotel_text: [
            'У цій подорожі ми обрали тільки найкращі та надійні готелі, щоб забезпечити вам комфортне та спокійне перебування. Кожен номер був ретельно вибраний, щоб стати ідеальним місцем для відпочинку після днів, сповнених пригод та досліджень.',
            'Нижче ви знайдете фотографії прекрасних місць для вашого перебування — або подібні високоякісні варіанти, уважно обрані для вашого комфорту.',
            'Подорожуйте з нами — ми подбали про всі деталі вашого ідеального відпочинку!',
        ],

        portugal_price_included: [
            '• Трансфери з аеропорту та в аеропорт',
            '• Туристичне страхування (базовий пакет)',
            '• Усі трансфери між локаціями',
            '• Зручне житло',
            '• Уроки серфінгу',
            '• Заняття йогою',
            '• Щоденні сніданки',
            '• Вечеря - знайомство',
            '• Тури, включаючи трансфери до Лісабону та Порто',
            '• Квитки для двох вибраних активностей'
        ],

        portugal_price_not_included: [
            '• Авіаквитки',
            '• Додаткові уроки серфінгу',
            '• Обіди та вечері (вечері-знайомства)'
        ],


        portugal_essential_items: [
            '• Купальники',
            '• Сонцезахисний крем, безпечний для рифів (високий SPF – сонце може бути сильним!)',
            '• Сонцезахисні окуляри з UV-захистом',
            '• Шльопанці або водонепроникні сандалі',
            '• Легкий, дихаючий одяг для теплих днів',
            '• Светр або легка куртка для прохолодних вечорів',
            '• Повсякденний одяг для дослідження міст',
            '• Спортивний одяг для розминок чи занять йогою',
            '• Шляпа або кепка для захисту від сонця',
            '• Особисті ліки',
        ],

        // faroe island
        faroe: "Фарерськи острови",
        faroe_price: "£890",
        faroe_date: "17-21 Вересня",
        faroe_date_calendar: '2025-09-17',

        faroe_upcoming: "Лагідний подих півночі",
        faroe_description_title: "ЛАГІДНИЙ ПОДИХ ПІВНОЧІ",
        faroe_descriptions: [
            "Відкрийте для себе захоплюючі пейзажі та унікальну культуру Фарерських островів. Від драматичних водоспадів і тихих озер до чарівних селищ і місцевих традицій — ця подорож подарує незабутні враження. Досліджуйте природну красу островів, насолоджуйтеся активними заняттями на свіжому повітрі та пізнавайте фарерські традиції.\n"
        ],

        faroe_img1: "ВОДОСПАДИ",
        faroe_img2: "МАЯК КАЛЛУР",
        faroe_img3: "ТРАДИЦІЇ",
        faroe_img4: "СКРАДСАФОССУР",
        faroe_img5: "ПІВДЕННЕ ОЗЕРО",
        faroe_img6: "ТУПІКИ",

        faroe_activity_d1: [
            "• Прибуття на Фарерські острови",
            "• Реєстрація в нашому житлі",
            "• Дослідження навколишніх територій"
        ],

        faroe_activity_d2: [
            "• Skardsafossur",
            "• Mykines"
        ],

        faroe_activity_d3: [
            "• Sørvágsvatn",
            "• Каякінг (за бажанням)",
            "• Стежка Witches Finger",
            "• Вечеря з фарерською родиною на фермі"
        ],

        faroe_activity_d4: [
            "• Маяк Kallur",
            "• Тур по дистилярні віскі та джину"
        ],

        faroe_activity_d5: [
            "• Фінальний сниданок",
            "• Прощання з Фарерськими остовами"
        ],
        faroe_d1: "Прибуття",
        faroe_d2: "Водоспади та острів Mykines",
        faroe_d3: "Sørvágsvatn, піший тур та місцева вечеря",
        faroe_d4: "Маяки та екскурсія до дистилярні",
        faroe_d5: "Сніданок та від'їзд",


        faroe_program_d1: [
            "Наша пригода починається з прибуття на Фарерські острови. Після того, як ми оселимося в готелі та зареєструємось, буде час дослідити навколишню місцевість, ознайомитись з острівними пейзажами та налаштуватися на майбутні дні. Сьогодні не буде великих планів — просто можливість розслабитись, перекусити та налаштуватись на наступні пригоди."
        ],

        faroe_program_d2: [
            "День розпочнеться з відвідування водоспаду Skardsafossur — це прихована перлина, яка не так популярна серед туристів, але варта уваги. Після цього ми відправимося на паром до острова Mykines, відомого своїми драматичними скелями та колоніями тупіків. Протягом дня ми будемо гуляти по стежках, насолоджуватись приголомшливими прибережними видами і спостерігати за птахами. Очікуйте свіжого морського повітря, величних ландшафтів і дикої краси Фарерських островів."
        ],

        faroe_program_d3: [
            "Спершу відвідаємо озеро Sørvágsvatn, яке має легендарну особливість — виглядає так, ніби воно висить над океаном. Ми прогуляємось по скелях, насолоджуючись ілюзією з найкращих точок огляду, а для тих, хто шукає більше пригод, буде можливість покататися на каное. Потім ми вирушимо на стежку Witches Finger Trail, яка веде до вражаючої скельної форми, де з вершини відкривається неймовірний панорамний вид. Завершимо день вечерею в традиційному фарерському фермерському будинку, де скуштуємо місцеві страви та познайомимося з життям на островах."
        ],

        faroe_program_d4: [
            "Ранок почнеться з відвідування маяка Kallur, який стоїть на скелях та пропонує захоплюючі краєвиди. Підйом на вершину не є складним, але пейзажі, які відкриваються, залишають незабутнє враження. Після цього ми відправимось на тур по дистилярні віскі та джину, де познайомимось із процесом виготовлення алкогольних напоїв за рецептами, що використовують місцеві інгредієнти — і звісно, закінчимо день дегустацією напоїв."
        ],

        faroe_program_d5: [
            "Останній ранок буде спокійним: ми разом поснідаємо, зберемо свої речі і попрощаємося з Фарерськими островами. Якщо у вас буде трохи більше часу до рейсу, ми зможемо зробити останню прогулянку і насолодитися останніми моментами цієї неймовірної подорожі."
        ],

        faroe_hotel_title: "Ваш комфорт — наша пріоритет",
        faroe_hotel_text: [
            "На Фарерських островах ми обрали комфортні готелі, які гарантують зручність і затишок. Хоча фотографії на сайті можуть не повністю збігатися з місцями, де ми будемо зупинятися, будьте впевнені, що вони будуть дуже схожі, а іноді й абсолютно однакові. Ми ретельно обираємо кожен готель, щоб забезпечити вам найкращий досвід перебування.",
            "Зверніть увагу, що номери будуть розподілені серед осіб однієї статі, з максимальним числом трьох осіб у кімнаті, щоб забезпечити комфорт і повагу протягом усього перебування."
        ],

        faroe_price_included: [
            "• Проживання",
            "• Трансфери до і з аеропорту",
            "• Трансфери між локаціями",
            "• Екскурсії до визначних місць",
            '• Туристичне страхування (базовий пакет)',
            "• Вечеря з фарерською родиною на фермі",
            "• Тур по дистилярні віскі та джину"
        ],

        faroe_price_not_included: [
            "• Авіаквитки",
            "• Харчування (ми ретельно обираємо доступні ресторани чи кафе, а коли це можливо, готуємо їжу разом в наших апартаментах)",
            "• Каякінг - £55"
        ],


        // vietnam
        vietnam: "В'єтнам",
        vietnam_date: '15-20 Липня',
        vietnam_date_calendar: '2022-07-15',
    }
};

export default translations;
